/**
 * Auth Utility - JWT Storage & Session Management
 * Handles token storage, expiry checks, and route protection
 */

const Auth = {
  TOKEN_KEY: "jwt_token",
  USER_KEY: "user_data",
  LOGIN_TIME_KEY: "login_time",
  EXPIRY_HOURS: 4,

  /**
   * Store token and user data after successful login
   */
  login(token, user) {
    localStorage.setItem(this.TOKEN_KEY, token);
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    localStorage.setItem(this.LOGIN_TIME_KEY, Date.now().toString());
  },

  /**
   * Clear auth data and redirect to login
   */
  logout() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_KEY);
    localStorage.removeItem(this.LOGIN_TIME_KEY);
    window.location.href = "index.html";
  },

  /**
   * Get stored JWT token
   */
  getToken() {
    return localStorage.getItem(this.TOKEN_KEY);
  },

  /**
   * Get stored user data
   */
  getUser() {
    const data = localStorage.getItem(this.USER_KEY);
    return data ? JSON.parse(data) : null;
  },

  /**
   * Check if user is logged in and token hasn't expired
   */
  isLoggedIn() {
    const token = this.getToken();
    if (!token) return false;

    // Check 4-hour expiry
    const loginTime = parseInt(
      localStorage.getItem(this.LOGIN_TIME_KEY) || "0",
    );
    const elapsed = Date.now() - loginTime;
    const maxAge = this.EXPIRY_HOURS * 60 * 60 * 1000;
    // const maxAge = 100;

    if (elapsed > maxAge) {
      this.logout();
      return false;
    }

    return true;
  },

  /**
   * Require authentication - redirect to login if not authenticated
   */
  requireAuth() {
    if (!this.isLoggedIn()) {
      window.location.href = "index.html";
      return false;
    }
    return true;
  },
};

// Auto-check token expiry every minute
setInterval(() => {
  if (Auth.getToken() && !Auth.isLoggedIn()) {
    Auth.logout();
  }
}, 60000);

export default Auth;
